export default function(val, type = 'rmb') {
    const typeList = {
        rmb: '￥',
        usd: '$'
    }
    const unit = typeList[type] || '￥'
        // return `${unit}${val}`.replace(/\.[0]+$/, '').slice(0, 5)
    return `${unit}${val}`.replace(/\.[0]+$/, '')
}
